const getters = {
  userInfo: state => state.user.info,

  token: state => state.user.token,
  userId: state => state.user.userId,
  name: state => state.user.name,

  channel: state => state.search.channel,
  // parkIds: state => state.search.parkIds,
  showVoice: state => state.search.showVoice,

  socketMsg: state => state.socket.socketMsg,
  loginHandleMsg: state => state.socket.loginHandleMsg

}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js